import { QueryRenderer, graphql } from "react-relay";
import Environment from "~/lib/relay/environment";

import usePreloadedRelayQuery from "~/lib/usePreloadedRelayQuery";

import AgentJobsList from "~/components/agent/AgentJobsList";
import SectionLoader from "~/components/shared/SectionLoader";

type AgentJobsListRendererProps = {
  params: {
    agent: string;
    organization: string;
  };
};

export default function AgentJobsListRenderer({ params, ...rest }: AgentJobsListRendererProps) {
  const environment = Environment.get();

  const query = graphql`
    query AgentJobsListRendererQuery($slug: ID!) {
      agent(slug: $slug) {
        ...AgentJobsList_agent
      }
    }
  `;

  usePreloadedRelayQuery(
    true,
    {
      environment,
      query,
      variables: { slug: `${params.organization}/${params.agent}` },
    },
    [params.agent, params.organization],
  );

  function renderQuery({ props }: { props: any }) {
    if (!props) {
      return <SectionLoader />;
    }

    return <AgentJobsList {...props} {...rest} />;
  }

  return (
    <QueryRenderer
      fetchPolicy="store-and-network"
      cacheConfig={{ force: true }}
      environment={environment}
      query={query}
      variables={{ slug: `${params.organization}/${params.agent}` }}
      render={renderQuery}
    />
  );
}
